import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { getDisplayName } from 'recompose';

export const withModal = ({ id }) => WrappedComponent => {
  const WithModal = ({
    isShown,
    handleHide,
    ...props
  }) => (
    <Modal
      id={id}
      show={isShown}
      onHide={handleHide}
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <WrappedComponent {...props} />
      </Modal.Body>
    </Modal>
  );
  WithModal.propTypes = {
    isShown: PropTypes.bool.isRequired,
    handleHide: PropTypes.func.isRequired,
  };
  WithModal.displayName = `withModal(${getDisplayName(WrappedComponent)})`;
  return WithModal;
};
